import {h} from 'preact';
import Metric from './Metric';
import BarGraph from './BarGraph';
import FlexTable from './FlexTable';
import Gauge from './Gauge';

export default function DashboardComponent (props) {
  const type = props.component.meta.properties.visualizationType;
  let jsxElement;
  switch (type) {
    case 'Metric':
      jsxElement = <Metric component={props.component} type={type} />;
      break;
    case 'Bar':
      jsxElement = <BarGraph component={props.component} type={type}/>;
      break;
    case 'FlexTable':
      jsxElement = <FlexTable component={props.component} type={type} />;
      break;
    case 'Gauge':
      jsxElement = <Gauge component={props.component} type={type} />;
      break;
    default:
      // Debug
      //console.log(`not yet renderable: component type ${props.component.meta.properties.visualizationType}`);
      //console.log(props.component);
      break;
  }

  return (
    <div
      id={"component--" + props.component.id}
      class={"component-wrapper component-wrapper--type__" + type}>
      {jsxElement}
    </div>
  );
}
